export default __webpack_public_path__ + "static/media/doc-icon.528aac45.svg";